import React, { useEffect } from "react";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import LearnMore from "../../../../components/learnMore/learnMore";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/zeroVisitsSagas";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import ZeroVisitsChart from "./smartComponents/ZeroVisitsChart";
import PeriodType from "./smartComponents/PeriodType";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import "./zeroVisitMembersChartModule.css.scss";
const ZeroVisitMembersChartModule = ({ params }) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    filtersDirty,
    updatesLoading,
    selectedRequestDates: { startDate, endDate }
  } = useSelector((state) => state.zeroVisits);
  const renderUpdateBtn = () => {
    let checkForInvalidDate = startDate !== "Invalid date" && endDate !== "Invalid date";
    if (filtersDirty && !isLoading && checkForInvalidDate) {
      return (
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>
      );
    }
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      );
    }
  };

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(params));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div>
              <div className="top-filter__left"></div>
            </div>
            <div className="top-filter">
              <div>
                <div className="top-filter__left"></div>
              </div>
              <div className="top-filter__right">
                <div className="select-box-no-width">
                  <p>Period Type</p>
                  <PeriodType />
                </div>

                <div className="select-box-no-width date-range-select-box">
                  <p>Date Range</p>
                  <CustomDateRanges />
                </div>
                <div className="date-select-box select-box-no-width multi">
                  <p>Date</p>
                  <DatePicker />
                </div>
                {renderUpdateBtn()}
                {renderResetBtn()}
              </div>
            </div>
          </div>
        </div>
        <div data-testid={"charts-container"} className="chart-root">
          {updatesLoading ? <LoadingAnimation text="Updating data..." /> : <ZeroVisitsChart />}
        </div>
      </div>
    );
  };
  return (
    <div id="ZeroVisitMembersChart-root">
      <SectionToggle
        autoHeight
        paddingBottom={0}
        height={690}
        title="Zero Visit Members"
        learnMore={<LearnMore {...learnMoreProps()} />}
        isLoading={isLoading}
        content={content()}
      />
    </div>
  );
};

export default ZeroVisitMembersChartModule;

const learnMoreProps = () => {
  return {
    learnMoreId: "ZeroVisitMembers",
    title: "Zero Visit Members",
    content: (
      <>
        This metric displays the percentage of active members who have had zero visits during the
        month. This is a wonderful indication of the health of a membership-base because the more
        zero visit members in your membership-base, the more terminations that will likely occur.
        <br />
        <br />
        Look to see if this is trending up or down. If the percentage of members with zero visits is
        increasing than there are more at risk members who could cancel. If less members have zero
        visits than membership health is likely trending up, good news!
        <br />
        <br />
        If you are feeling brave, call or email all these members to get them back in. If you are
        not confident in contacting members that haven't visited for a long period of time, click
        the <b>Last Visit</b> column to sort soonest to latest. Sorting by last visit will quickly
        find people that have not been gone too long. Ideally, you can find members that have had a
        visit less than 30 days ago and encourage them to come back.
        <br />
        <br />
        <b>Remember:</b> it is easier and more cost effective to keep existing members than to spend
        marketing money or goodwill to obtain a new member.
      </>
    )
  };
};
